import React from 'react';
import { Heading2 } from "components/common/Typography";
import { Flex } from "components/common/Responsive";
import PageWrapper from "containers/PageWrapper";

function NotFound () {
  return (
    <PageWrapper>
      <Flex
        my={"40px"}
        maxWidth={"1100px"}
        width={1}
        flexDirection="column"
        px={["24px", "24px", 0]}
      >
        <Heading2
          mt={[0, 0, "60px"]}
          fontSize={"60px"}
          lineHeight={"73px"}
          textAlign="center"
        >
          Puslapis kurio ieškote mūsų svetainėje neegzistuoja
        </Heading2>
      </Flex>
    </PageWrapper>
  )
}

export default NotFound
